import axios from "axios";

import { refreshToken } from "./RefreshToken";

export default async function getAPIResponse(endpoint, data = {}, method = "get", options = {}) {
	var response = null;
	try {
		response = await axios({
			method: method,
			url: `${process.env.REACT_APP_BACKEND_URL}${endpoint}`,
			data: data,
			signal: options.signal,
			headers: {
				Authorization: `Bearer ${
					localStorage.getItem(process.env.REACT_APP_TOKEN_NAME)
				}`
			}
		});
		return response.data;
	} catch (error) {
		if (error && (error.name === 'CanceledError' || error.code === 'ERR_CANCELED')) {
			return null;
		}
		try {
			await refreshToken();
			response = await axios({
				method: method,
				url: `${process.env.REACT_APP_BACKEND_URL}${endpoint}`,
				data: data,
				signal: options.signal,
				headers: {
					Authorization: `Bearer ${
						localStorage.getItem(process.env.REACT_APP_TOKEN_NAME)
					}`
				}
			});
			return response.data;
		} catch (error) {
			return null;
		}
	}
}
